import LegalLayout from "./_LegalLayout";

export default function Privacy() {
    return (
        <LegalLayout title="Privacy Policy" subtitle="Informativa sul trattamento dei dati personali">
            <p className="text-sm text-ink-muted">Ultimo aggiornamento: dicembre 2025</p>

            <h2>1. Titolare del trattamento</h2>
            <p>Il titolare del trattamento dei dati personali è <strong>7MED GROUP</strong>, con sede in Via Luigi Lavizzari 2, 6850 Mendrisio (Svizzera). Email: backoffice@7med.ch — Tel +41 91 261 51 99.</p>

            <h2>2. Tipologie di dati raccolti</h2>
            <p>Raccogliamo solo i dati strettamente necessari a fornire i nostri servizi e a rispondere alle vostre richieste:</p>
            <ul>
                <li>Dati identificativi (nome, cognome)</li>
                <li>Dati di contatto (email, telefono, indirizzo postale)</li>
                <li>Dati relativi all'azienda (ragione sociale, ruolo)</li>
                <li>Dati relativi al corso (data di nascita per attestati, sede preferita)</li>
                <li>Dati di navigazione (cookie tecnici e analitici tramite Google Analytics)</li>
            </ul>

            <h2>3. Finalità del trattamento</h2>
            <ul>
                <li>Riscontro alle richieste di preventivo o iscrizione corso</li>
                <li>Erogazione dei servizi formativi e rilascio attestati</li>
                <li>Adempimenti contrattuali e fiscali</li>
                <li>Analisi statistica anonimizzata sul traffico del sito</li>
            </ul>

            <h2>4. Base giuridica</h2>
            <p>Il trattamento si basa sul consenso dell'interessato (LPD svizzera, RGPD UE per cittadini europei), sull'esecuzione di un contratto e su obblighi legali.</p>

            <h2>5. Comunicazione e trasferimento</h2>
            <p>I dati possono essere trattati da fornitori esterni (es. SendGrid per l'invio email, Google per Analytics) con cui sono in essere accordi di trattamento dati conformi alla normativa svizzera (LPD) ed europea (RGPD).</p>

            <h2>6. Periodo di conservazione</h2>
            <p>I dati di contatto vengono conservati per il tempo strettamente necessario al raggiungimento delle finalità o per il periodo richiesto dalla legge svizzera (in particolare 10 anni per dati fiscalmente rilevanti).</p>

            <h2>7. Diritti dell'interessato</h2>
            <p>Hai diritto di accedere, rettificare, cancellare i tuoi dati, di limitarne il trattamento, di opporti al trattamento e di richiederne la portabilità. Per esercitare i tuoi diritti scrivi a <a href="mailto:backoffice@7med.ch">backoffice@7med.ch</a>.</p>

            <h2>8. Cookie</h2>
            <p>Utilizziamo cookie tecnici necessari al funzionamento del sito e cookie analitici (Google Analytics 4 con IP anonimizzato) per misurare il traffico. Puoi disabilitare i cookie tramite le impostazioni del browser.</p>

            <h2>9. Reclami</h2>
            <p>In caso di violazione dei tuoi diritti, puoi rivolgerti all'<strong>Incaricato federale della protezione dei dati e della trasparenza (IFPDT)</strong> — Feldeggweg 1, 3003 Berna.</p>
        </LegalLayout>
    );
}
